import script from "./TariffConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./TariffConfig.vue?vue&type=script&lang=ts&setup=true"

import "./TariffConfig.vue?vue&type=style&index=0&id=af8f8730&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af8f8730"]])

export default __exports__